var _templateObject, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import styled from '@emotion/styled';
import MUISvgIcon, { svgIconClasses } from '@mui/material/SvgIcon';
import * as React from "react";
var SvgIcon = styled(MUISvgIcon)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &.", " {\n    width: ", ";\n    height: ", ";\n    color: ", ";\n    stroke-width: 1px;\n    vector-effect: non-scaling-stroke;\n  }\n"])), svgIconClasses.root, function (_ref) {
  var size = _ref.size,
    theme = _ref.theme;
  return size && theme.size[size];
}, function (_ref2) {
  var size = _ref2.size,
    theme = _ref2.theme;
  return size && theme.size[size];
}, function (_ref3) {
  var color = _ref3.color,
    theme = _ref3.theme;
  return color && theme.color[color];
});
var SvgLoading = function SvgLoading(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "loading_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "loading_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "loading_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16 2v16c0 1.1-.9 2-2 2H2c-1.1 0-2-.9-2-2V2C0 .9.9 0 2 0h12c1.1 0 2 .9 2 2"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#loading_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E7E2D1",
    d: "M1.5 30C.67 30 0 29.33 0 28.5V9.19c0-1.32.55-2.6 1.55-3.6l4.04-4.04C6.59.55 7.87 0 9.19 0h15.86C27.78 0 30 2.22 30 4.95V28.5c0 .83-.67 1.5-1.5 1.5z",
    style: {
      display: "block"
    },
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#loading_svg__b)",
    style: {
      display: "block"
    },
    transform: "translate(11 5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#loading_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8B8DAD",
    d: "M16 2v16c0 1.1-.9 2-2 2H2c-1.1 0-2-.9-2-2V2C0 .9.9 0 2 0h12c1.1 0 2 .9 2 2",
    style: {
      display: "block"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#15FF64",
    d: "M2 0v5H0V0z",
    opacity: 0.412,
    style: {
      display: "block"
    },
    transform: "translate(2 2)"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#0E0E0E",
    d: "M26.27 0h-16.2C8.54 0 7.06.64 5.91 1.79L1.79 5.91C.64 7.06 0 8.54 0 10.07v19.71C0 31 1 32 2.22 32h27.56C31 32 32 31 32 29.78V5.73C32 2.57 29.43 0 26.27 0m0 1.37c2.41 0 4.36 1.95 4.36 4.36v24.05c0 .47-.38.85-.85.85H2.22a.85.85 0 0 1-.85-.85V10.07c0-1.26.56-2.37 1.38-3.19l4.13-4.13c.83-.83 1.93-1.38 3.19-1.38z",
    style: {
      display: "block"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0E0E0E",
    d: "M2.49 1.34c-.64 0-1.17.52-1.17 1.17v16.98c0 .65.53 1.17 1.17 1.17h11.7c.64 0 1.16-.52 1.16-1.17V2.51c0-.65-.52-1.17-1.16-1.17zM15.51 22H2.49C1.12 22 0 20.87 0 19.49V2.51C0 1.13 1.12 0 2.49 0h13.02C16.88 0 18 1.13 18 2.51v16.98c0 1.38-1.12 2.51-2.49 2.51",
    style: {
      display: "block"
    },
    transform: "translate(10 4)"
  }))));
};
export default SvgLoading;